import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BannerModel } from '../models/banner.model';
import { BannerRepository } from '../repositories/banner.repository';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  constructor(
    private bannerRepository: BannerRepository
  ) { }

  public getAll(): Observable<Array<BannerModel>> {
    return this.bannerRepository.getAll();
  }

}
